import { terms } from 'lib/terms'

import { TermsLayout } from 'components/v2/TermsLayout/TermsLayout'

const PrivacyPolicy = ({ content }) => {
	const metaTags = {
		title: 'Política de Privacidade | Vittude'
	}

	return <TermsLayout content={content} metaTags={metaTags} />
}

export async function getStaticProps() {
	const file = await terms('politica-privacidade.md')
	const content = file.replace(/\r/g, '').trim()

	return {
		props: {
			content
		}
	}
}

export default PrivacyPolicy
